import axios from 'axios';
import { BASEURL } from '../../baseUrl';
import { toast } from 'react-toastify';

// ===== Action Types =====
export const CREATE_IVR_CREDENTIAL = 'CREATE_IVR_CREDENTIAL';
export const UPDATE_IVR_CREDENTIAL = 'UPDATE_IVR_CREDENTIAL';
export const GET_IVR_CREDENTIAL = 'GET_IVR_CREDENTIAL';
export const CALL_LEAD = 'CALL_LEAD';
export const CALL_DIALER = 'CALL_DIALER';
export const GET_INCOMING_CALL = 'GET_INCOMING_CALL';
export const GET_OUTGOING_CALL = 'GET_OUTGOING_CALL';

// ===== Action Creators =====
const createIvrCredentialAction = (payload) => ({ type: CREATE_IVR_CREDENTIAL, payload });
const updateIvrCredentialAction = (payload) => ({ type: UPDATE_IVR_CREDENTIAL, payload });
const getIvrCredentialAction = (payload) => ({ type: GET_IVR_CREDENTIAL, payload });
const callLeadAction = (payload) => ({ type: CALL_LEAD, payload });
const callDialerAction = (payload) => ({ type: CALL_DIALER, payload });
const getIncomingCallAction = (payload) => ({ type: GET_INCOMING_CALL, payload });
const getOutgoingCallAction = (payload) => ({ type: GET_OUTGOING_CALL, payload });

// ===== POST /api/ivr/credential/create =====
export const createIvrCredential = (payload) => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem('token');
      await axios
        .post(`${BASEURL}/ivr/credential/create`, payload, {
          headers: { authorization: `Bearer ${token}` },
        })
        .then((res) => {
          toast.success('IVR Credential Created successfully');
          dispatch(createIvrCredentialAction(res));
        })
        .catch((error) => {
          console.log('Error', error);
          toast.error(error?.response?.data?.message || 'Failed to create credential');
          dispatch(createIvrCredentialAction(error?.response));
        });
    } catch (error) {
      console.log('Error creating IVR credential:', error);
    }
  };
};

// ===== PUT /api/ivr/credential/update/:id =====
export const updateIvrCredential = (id, payload) => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem('token');
      await axios
        .put(`${BASEURL}/ivr/credential/update/${id}`, payload, {
          headers: { authorization: `Bearer ${token}` },
        })
        .then((res) => {
          toast.success('IVR Credential Updated successfully');
          dispatch(updateIvrCredentialAction(res));
          dispatch(getIvrCredential());
        })
        .catch((error) => {
          console.log('Error', error);
          toast.error(error?.response?.data?.message || 'Failed to update credential');
          dispatch(updateIvrCredentialAction(error?.response));
        });
    } catch (error) {
      console.log('Error updating IVR credential:', error);
    }
  };
};

// ===== GET /api/ivr/credential/get =====
export const getIvrCredential = () => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem('token');
      await axios
        .get(`${BASEURL}/ivr/credential/get`, {
          headers: { authorization: `Bearer ${token}` },
        })
        .then((res) => {
          dispatch(getIvrCredentialAction(res));
        })
        .catch((error) => {
          console.log('Error', error);
          dispatch(getIvrCredentialAction(error?.response));
        });
    } catch (error) {
      console.log('Error fetching IVR credential:', error);
    }
  };
};

// ===== POST /api/ivr/ctc/callLead/:leadId?entityType=lead =====
export const callLead = (leadId, entityType = 'lead') => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem('token');
      await axios
        .post(
          `${BASEURL}/ivr/ctc/callLead/${leadId}?entityType=${entityType}`,
          {},
          { headers: { authorization: `Bearer ${token}` } },
        )
        .then((res) => {
          toast.success('Call Initiated successfully');
          dispatch(callLeadAction(res));
        })
        .catch((error) => {
          console.log('Error', error);
          toast.error(error?.response?.data?.message || 'Failed to initiate call');
          dispatch(callLeadAction(error?.response));
        });
    } catch (error) {
      console.log('Error calling lead:', error);
    }
  };
};

// ===== POST /api/ivr/ctc/call  body: { number } =====
export const callFromDialer = (number) => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem('token');
      await axios
        .post(
          `${BASEURL}/ivr/ctc/call`,
          { number },
          { headers: { authorization: `Bearer ${token}` } },
        )
        .then((res) => {
          toast.success('Call Initiated successfully');
          dispatch(callDialerAction(res));
        })
        .catch((error) => {
          console.log('Error', error);
          toast.error(error?.response?.data?.message || 'Failed to initiate call');
          dispatch(callDialerAction(error?.response));
        });
    } catch (error) {
      console.log('Error calling from dialer:', error);
    }
  };
};

// ===== GET /api/ivr/ctc/incoming-call =====
// query params supported by backend: page, limit, startDate, endDate, search, callNumber
export const getIncomingCallHistory = (params) => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem('token');
      const queryParams = new URLSearchParams(params).toString();
      await axios
        .get(`${BASEURL}/ivr/ctc/incoming-call?${queryParams}`, {
          headers: { authorization: `Bearer ${token}` },
        })
        .then((res) => {
          dispatch(getIncomingCallAction(res));
        })
        .catch((error) => {
          console.log('Error', error);
          dispatch(getIncomingCallAction(error?.response));
        });
    } catch (error) {
      console.log('Error fetching incoming call history:', error);
    }
  };
};

// ===== GET /api/ivr/ctc/outgoing-call =====
// query params supported by backend: page, limit, startDate, endDate, search, callNumber
export const getOutgoingCallHistory = (params) => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem('token');
      const queryParams = new URLSearchParams(params).toString();
      await axios
        .get(`${BASEURL}/ivr/ctc/outgoing-call?${queryParams}`, {
          headers: { authorization: `Bearer ${token}` },
        })
        .then((res) => {
          dispatch(getOutgoingCallAction(res));
        })
        .catch((error) => {
          console.log('Error', error);
          dispatch(getOutgoingCallAction(error?.response));
        });
    } catch (error) {
      console.log('Error fetching outgoing call history:', error);
    }
  };
};